import React, { useEffect, useRef } from 'react';

const EmojiPicker = ({ onEmojiSelect, onClose, position = 'bottom' }) => {
  const pickerRef = useRef(null);
  
  // Common emojis for social media interaction
  const commonEmojis = [
    '👍', '❤️', '😊', '😂', '🙌', '👏', '🔥', '💯', '🎉', '👀',
    '😍', '🤔', '👌', '🙏', '😎', '✨', '🥳', '😃', '🤣', '😉',
    '💪', '👋', '🌟', '💖', '😁', '🙂', '💕', '😘', '🤗', '👊'
  ];
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose();
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);
  
  const getPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'bottom-full mb-2';
      case 'bottom':
        return 'top-full mt-2';
      case 'left':
        return 'right-full mr-2';
      case 'right':
        return 'left-full ml-2';
      default:
        return 'top-full mt-2';
    }
  };

  return (
    <div 
      ref={pickerRef}
      className={`absolute ${getPositionClasses()} right-0 z-10 bg-white border border-gray-200 rounded-lg shadow-lg p-2 w-64`}
    >
      <div className="grid grid-cols-6 gap-1">
        {commonEmojis.map((emoji, index) => (
          <button
            key={index}
            onClick={() => onEmojiSelect(emoji)}
            className="text-xl p-1 hover:bg-gray-100 rounded transition-colors"
            aria-label={`Emoji ${emoji}`}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmojiPicker;